app.factory(
    'HelpService', ['LocalStorage', 'Configuration', 'ApiService', 'Upload', '$rootScope', '$http', '$window', HelpService]
);

function HelpService(LocalStorage, Configuration, ApiService, UploadServcie, $rootScope, $http, $window) {
    self.GetHelpIndex = GetHelpIndex;
    self.Delete = Delete;
    self.Download = Download;
    self.NewFolder = NewFolder;
    self.PlayVideo = PlayVideo;
    self.SaveNotes = SaveNotes;
    self.Rename = Rename;
    self.UploadHelp = UploadHelp;
    self.UploadThumbnail = UploadThumbnail;

    function GetHelpIndex(path) {
        var request = ApiService.get("/api/HelpApi/GetIndex?path=" + path);
        return request;
    }

    function Delete(path) {
        var request = ApiService.get("/api/HelpApi/Delete?path=" + path);
        return request;
    }

    function Download(path, contentType) {
        return $http({
            method: 'GET',
            url: Configuration.api.url + '/api/HelpApi/Download?path=' + path,
            params: { },
            responseType: 'arraybuffer'
        }).then(function (response) {
            var headers = response.headers();
            var filename = headers['x-filename'];
            var linkElement = document.createElement('a');
            try {
                var blob = new Blob([response.data], { type: contentType });

                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    var url = window.URL.createObjectURL(blob);
                    linkElement.setAttribute('href', url);
                    if (contentType === headers["content-type"]) {
                        linkElement.setAttribute("download", filename);
                    }

                    linkElement.setAttribute('target', '_self');

                    var clickEvent = new MouseEvent("click", {
                        "view": window,
                        "bubbles": true,
                        "cancelable": false
                    });
                    linkElement.dispatchEvent(clickEvent);
                }
            } catch (ex) {
                console.log(ex);
            }
        });
    }

    function NewFolder(path) {
        var request = ApiService.get("/api/HelpApi/NewFolder?path=" + path);
        return request;
    }

    function PlayVideo(path, contentType) {
        return $http({
            method: 'GET',
            url: Configuration.api.url + '/api/HelpApi/VideoStream?path=' + path,
            params: {},
            responseType: 'arraybuffer'
        }).then(function (response) {
            let player = document.getElementById("videoPlayer");

            var blob = new Blob([response.data], { type: "video/" + contentType });

            let videoUrl = window.URL.createObjectURL(blob);
            player.src = videoUrl;
        });
    }

    function Rename(oldvalue, newvalue) {
        var request = ApiService.get("/api/HelpApi/Rename?oldvalue=" + oldvalue + "&newvalue=" + newvalue);
        return request;
    }
    
    function SaveNotes(item) {
        var request = ApiService.post("/api/HelpApi/SaveNotes", item);

        return request;
    }

    function UploadHelp(path, files) {
        var request = UploadServcie.upload({
            url: Configuration.api.url + "/api/HelpApi/UploadHelp?path=" + path,
            data: {
                files: files
            }
        });

        return request;
    }

    function UploadThumbnail(path, files) {
        var request = UploadServcie.upload({
            url: Configuration.api.url + "/api/HelpApi/UploadThumbnail?path=" + path,
            data: {
                files: files
            }
        });

        return request;
    }

    return self;
}